module.exports = __webpack_public_path__ + "static/media/TopZone-bg2-blur.ce99d4eb.png";